<div id="itemspage">
    <!-- head -->
    <div id="ip-head" [style.background-image]="'url(\'/images/cats/'+cat.img+'\')'" *ngIf="catReady">
        <div id="ip-head-content">
            <h1 [innerHTML]="(cat.diff_name && cat.diff_name[currentLang.slug]) || cat.h1[currentLang.slug] || cat.name[currentLang.slug]"></h1>
            <cat-timer [cat]="cat"></cat-timer>
        </div>        
    </div>
    <!-- filter -->
    <the-filter [ready]="filterReady" [filter]="filter" [showInARow]="showInARow" (showInARowChanged)="onShowInARowChanged($event)" (apply)="applyFilters();"></the-filter>        
    <!-- items -->    
    <ng-container *ngIf="itemsReady">
        <div id="ip-items" [class.one-in-a-row]="showInARow==1">
            <div *ngFor="let item of filteredItems">
                <cat-item [item]="item"></cat-item>
            </div>        
        </div>  
    </ng-container>    
    <ng-container *ngIf="!itemsReady">
        <div class="compact smallpadded">
            <div class="loading">{{currentLang.s['common']['loading']}}</div>
        </div>
    </ng-container>  
</div>
